"use client";

import { FileText } from "lucide-react";
import { useTranslations } from "next-intl";
import DocumentosPorAnio from "./DocumentosPorAnio";

interface DocumentosSinGrupoProps {
  documentosPorAnio: {
    anio: number;
    documentos: {
      id: number;
      titulo: string;
      archivo: string;
      formato: string;
      anio: number;
      seguimientos?: {
        id: number;
        tipo: string;
        titulo: string;
        archivo: string;
        formato: string;
      }[];
    }[];
  }[];
}

export default function DocumentosSinGrupo({
  documentosPorAnio,
}: DocumentosSinGrupoProps) {
  const t = useTranslations("transparenciaPage");
  if (!documentosPorAnio || documentosPorAnio.length === 0) return null;

  return (
    <div className="mt-2">
      <div className="flex items-center gap-2 mb-3">
        <FileText className="w-4 h-4 text-[#102542]" />
        <span className="text-xs uppercase tracking-wider font-semibold text-gray-700">
          {t("documentosGenerales")}
        </span>
      </div>
      <DocumentosPorAnio
        documentosPorAnio={documentosPorAnio}
        cardVariant="white"
      />
    </div>
  );
}
